import { Component } from '@angular/core';

@Component({
  selector: 'icon-stop',
  standalone: true,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 33" fill="none">
      <g clip-path="url(#clip0_106_1091)">
        <path d="M31 16.5C31 24.7843 24.2843 31.5 16 31.5C7.71573 31.5 1 24.7843 1 16.5C1 8.21573 7.71573 1.5 16 1.5C24.2843 1.5 31 8.21573 31 16.5ZM12.8 10.7C11.3641 10.7 10.2 11.8641 10.2 13.3V19.7C10.2 21.1359 11.3641 22.3 12.8 22.3H19.2C20.6359 22.3 21.8 21.1359 21.8 19.7V13.3C21.8 11.8641 20.6359 10.7 19.2 10.7H12.8ZM12.2 13.3C12.2 12.9686 12.4686 12.7 12.8 12.7H19.2C19.5314 12.7 19.8 12.9686 19.8 13.3V19.7C19.8 20.0314 19.5314 20.3 19.2 20.3H12.8C12.4686 20.3 12.2 20.0314 12.2 19.7V13.3Z" stroke="#0C8080" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
    <defs>
      <clipPath id="clip0_106_1091">
        <rect width="32" height="32" fill="white" transform="translate(0 0.5)"/>
      </clipPath>
    </defs>
    </svg>
  `,
  styles: [
   `
    @import '../../assets/colors.scss';

    svg {
        width: 35px;
        height: 35px;
        /* @media only screen and (max-width: 475px) {
          width: 45px;
          height: 45px;
        } */
        path {
          fill: #fff!important;
          stroke: $header-color;
        }
      }`
  ]
})

export class StopIconComponent {

}
